import React from 'react'
import { Button, Grid, Icon } from 'gu-ui-kit'
import styles from 'components/Banners/SliderBanner/slider-banner.module.scss'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const SlideButtons = ({ banners, currentBannerNum, setCurrentBannerNum, className }) =>
  banners.length > 0 && (
    <Grid direction={'row'} gap={8} className={className} wrap={false} alignItems={'center'}>
      <Button
        className={styles['button']}
        color={'Interface-Seventh'}
        noLabel
        size={'s'}
        variant={'ghost'}
        grey
        onClick={() => setCurrentBannerNum((curr) => (curr === 0 ? banners.length - 1 : curr - 1))}
        startIcon={
          <Icon
            className={styles['breadcrumbs__arrow']}
            name={'arrow-left'}
            size={'m'}
            color={'Interface-Sixth'}
          />
        }
      />

      {banners.map((item, i) => (
        <span
          className={clsx(styles['point'], {
            [styles['point_active']]: i === currentBannerNum,
          })}
          key={'banner-' + i}
          onClick={() => setCurrentBannerNum(i)}
        ></span>
      ))}

      <Button
        className={styles['button']}
        color={'Interface-Seventh'}
        noLabel
        size={'s'}
        variant={'ghost'}
        grey
        onClick={() => setCurrentBannerNum((curr) => (curr === banners.length - 1 ? 0 : curr + 1))}
        startIcon={
          <Icon
            className={styles['breadcrumbs__arrow']}
            name={'arrow-right'}
            size={'m'}
            color={'Interface-Sixth'}
          />
        }
      />
    </Grid>
  )

export default SlideButtons

SlideButtons.propTypes = {
  banners: PropTypes.array,
  setCurrentBannerNum: PropTypes.func,
  className: PropTypes.string,
  currentBannerNum: PropTypes.number,
}
